import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.some.js";
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "tags-close-box"
};
import { useTagsStore } from '@/store/tags';
import { onBeforeRouteUpdate, useRoute, useRouter } from 'vue-router';
import { ArrowDown, Close } from "@element-plus/icons-vue";
import { checkAdminSession } from "@/store/cache";
import { ElMessageBox } from "element-plus";
import { useSharedStore } from "@/store/sharedata";
import { ref, watch } from "vue";
export default {
  __name: 'AdminTags',
  setup(__props) {
    const store = useSharedStore();
    const theme = ref(store.theme);
    watch(() => store.theme, val => {
      theme.value = val;
    });
    const router = useRouter();
    checkAdminSession().catch(() => {
      ElMessageBox({
        title: '提示',
        message: "当前会话已经失效，请重新登录",
        confirmButtonText: 'OK',
        callback: () => router.replace('/admin/login')
      });
    });
    const isActive = path => {
      return path === route.fullPath;
    };
    const tags = useTagsStore();
    const route = useRoute();
    // 关闭单个标签
    const closeTags = index => {
      const delItem = tags.list[index];
      tags.delTagsItem(index);
      const item = tags.list[index] ? tags.list[index] : tags.list[index - 1];
      if (item) {
        delItem.path === route.fullPath && router.push(item.path);
      } else {
        router.push('/admin');
      }
    };

    // 设置标签
    const setTags = route => {
      const isExist = tags.list.some(item => {
        return item.path === route.fullPath;
      });
      if (!isExist) {
        if (tags.list.length >= 8) tags.delTagsItem(0);
        tags.setTagsItem({
          name: route.name,
          title: route.meta.title,
          path: route.fullPath
        });
      }
    };
    setTags(route);
    onBeforeRouteUpdate(to => {
      setTags(to);
    });

    // 关闭全部标签
    const closeAll = () => {
      tags.clearTags();
      router.push('/admin');
    };
    // 关闭其他标签
    const closeOther = () => {
      const curItem = tags.list.filter(item => {
        return item.path === route.fullPath;
      });
      tags.closeTagsOther(curItem);
    };
    const handleTags = command => {
      command === 'other' ? closeOther() : closeAll();
    };

    // 关闭当前页面的标签页
    // tags.closeCurrentTag({
    //     $router: router,
    //     $route: route
    // });

    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      return _unref(tags).show ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass('tags ' + theme.value)
      }, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tags).list, (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          class: _normalizeClass(["tags-li", {
            active: isActive(item.path)
          }]),
          key: index
        }, [_createVNode(_component_router_link, {
          to: item.path,
          class: "tags-li-title"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1)]),
          _: 2
        }, 1032, ["to"]), _createVNode(_component_el_icon, {
          onClick: $event => closeTags(index)
        }, {
          default: _withCtx(() => [_createVNode(_unref(Close))]),
          _: 2
        }, 1032, ["onClick"])], 2);
      }), 128))]), _createElementVNode("div", _hoisted_1, [_createVNode(_component_el_dropdown, {
        onCommand: handleTags
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, {
          size: "small"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
            command: "other"
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("关闭其他")])),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            command: "all"
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("关闭所有")])),
            _: 1
          })]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_button, {
          size: "small",
          type: "info"
        }, {
          default: _withCtx(() => [_cache[0] || (_cache[0] = _createTextVNode(" 标签选项 ")), _createVNode(_component_el_icon, {
            class: "el-icon--right"
          }, {
            default: _withCtx(() => [_createVNode(_unref(ArrowDown))]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })])], 2)) : _createCommentVNode("", true);
    };
  }
};